import UISchemaJson from "./UISchema.json";

const schema = JSON.parse(JSON.stringify(UISchemaJson));
const categories = schema.elements?.[0]?.elements?.[0]?.elements || [];
const generalIndex = categories.findIndex((item: any) => item.label === "Configurações gerais");
const contentIndex = categories.findIndex((item: any) => item.label === "Conteúdo");

const containsScope = (element: any, scope: string): boolean =>
  element?.scope === scope || (element?.elements || []).some((child: any) => containsScope(child, scope));

if (generalIndex >= 0 && contentIndex >= 0) {
  const generalElements = categories[generalIndex].elements || [];
  const publicContentElements = categories[contentIndex].elements || [];
  const eventDatesIndex = generalElements.findIndex((element: any) =>
    containsScope(element, "#/properties/dateInit")
  );
  const publicationDatesIndex = generalElements.findIndex((element: any) =>
    containsScope(element, "#/properties/publishOn")
  );

  if (eventDatesIndex >= 0 && publicationDatesIndex >= 0) {
    const [eventDates] = generalElements.splice(eventDatesIndex, 1);
    const adjustedPublicationIndex = publicationDatesIndex > eventDatesIndex
      ? publicationDatesIndex - 1
      : publicationDatesIndex;
    const [publicationDates] = generalElements.splice(adjustedPublicationIndex, 1);
    generalElements.splice(eventDatesIndex, 0, publicationDates);
    publicContentElements.unshift(eventDates);
  }
}

if (generalIndex >= 0 && contentIndex >= 0) {
  const content = categories[contentIndex];
  categories[generalIndex].elements.push({
    type: "Group",
    label: "Conteúdo e programação do evento",
    elements: content.elements,
  });
  categories.splice(contentIndex, 1);

  const generalElements = categories[generalIndex].elements || [];
  const auditIndex = generalElements.findIndex((element: any) =>
    containsScope(element, "#/properties/createdAt")
  );
  if (auditIndex >= 0 && auditIndex !== generalElements.length - 1) {
    const [auditDates] = generalElements.splice(auditIndex, 1);
    generalElements.push(auditDates);
  }
}

const currentGeneralIndex = categories.findIndex((item: any) => item.label === "Configurações gerais");
const financialIndex = categories.findIndex((item: any) => item.label === "Financeiro");

if (currentGeneralIndex >= 0 && financialIndex >= 0 && financialIndex !== currentGeneralIndex + 1) {
  const [financial] = categories.splice(financialIndex, 1);
  categories.splice(currentGeneralIndex + 1, 0, financial);
}

const supportIndex = categories.findIndex((item: any) => item.label === "Apoio e infraestrutura");
if (supportIndex >= 0) {
  const [support] = categories.splice(supportIndex, 1);
  categories.push(support);
} else {
  categories.push({
    type: "Category",
    label: "Apoio e infraestrutura",
    elements: [{ type: "Control", scope: "#", options: { EventSupportManagement: true } }],
  });
}

export default schema;
